import { type Column, type IId, Table } from '@synqo/frontend-component-library';
import { type RowSelector } from './useContainerSelection';

interface ContainerStockLinesProps<TLine extends IId> {
    /** Prefixes the name of the table. */
    name?: string;
    group: { id: string; lines: TLine[] };
    columns: Readonly<Column<TLine>>[];
    /** Called with the line that was clicked. */
    onSelect?: (line: TLine) => boolean;
    /** Makes the lines selectable. */
    objectSelector?: RowSelector;
}

/**
 * The standing times a group is made of, shown beneath it when it is expanded.
 */
// @ai-generated 2026-10-02T08:10:14+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function ContainerStockLines<TLine extends IId>({
    name = 'container_stock_lines',
    group,
    columns,
    onSelect,
    objectSelector,
}: ContainerStockLinesProps<TLine>) {
    return (
        <Table<TLine>
            name={`${name}_${group.id}`}
            columns={columns}
            items={group.lines}
            onSelect={onSelect}
            objectSelector={objectSelector}
            disableTopToolbar
        />
    );
}
